import React from 'react';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { businessInfo } from '../mockData';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
const Contact = () => {
  return (
    <section id="contact" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Contact Us Today
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Ready to get started? Give us a call or send us an email for a free, no-obligation quote.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          {/* Contact Info Cards */}
          <div className="grid md:grid-cols-2 gap-6 mb-12">
            <Card className="border-2 border-orange-200 hover:shadow-lg transition-shadow">
              <CardContent className="pt-6">
                <div className="flex items-start gap-4">
                  <div className="w-14 h-14 bg-orange-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Phone className="text-orange-600" size={28} />
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 mb-2 text-lg">Call Us</h3>
                    <a href={`tel:${businessInfo.phone}`} className="text-orange-600 hover:text-orange-700 font-bold text-2xl block mb-2">
                      {businessInfo.phone}
                    </a>
                    <p className="text-sm text-gray-600">Call for immediate assistance</p>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="border-2 border-orange-200 hover:shadow-lg transition-shadow">
              <CardContent className="pt-6">
                <div className="flex items-start gap-4">
                  <div className="w-14 h-14 bg-orange-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Mail className="text-orange-600" size={28} />
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 mb-2 text-lg">Email Us</h3>
                    <a href={`mailto:${businessInfo.email}`} className="text-orange-600 hover:text-orange-700 font-semibold text-lg block mb-2 break-all">
                      {businessInfo.email}
                    </a>
                    <p className="text-sm text-gray-600">Send us your inquiry</p>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="border-2 border-orange-200 hover:shadow-lg transition-shadow">
              <CardContent className="pt-6">
                <div className="flex items-start gap-4">
                  <div className="w-14 h-14 bg-orange-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <MapPin className="text-orange-600" size={28} />
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 mb-2 text-lg">Visit Us</h3>
                    <p className="text-gray-700 font-medium mb-2">{businessInfo.address}</p>
                    <p className="text-sm text-gray-600">Serving the Lakeshore area</p>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="border-2 border-orange-200 hover:shadow-lg transition-shadow">
              <CardContent className="pt-6">
                <div className="flex items-start gap-4">
                  <div className="w-14 h-14 bg-orange-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Clock className="text-orange-600" size={28} />
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 mb-2 text-lg">Business Hours</h3>
                    <p className="text-gray-700 font-medium mb-2">{businessInfo.hours}</p>
                    <p className="text-sm text-gray-600">24/7 emergency service available</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>

          {/* Call to Action */}
          <div className="bg-gradient-to-r from-orange-600 to-orange-500 rounded-2xl p-8 md:p-12 text-center text-white shadow-xl">
            <h3 className="text-3xl md:text-4xl font-bold mb-4">
              Ready for Your Free Quote?
            </h3>
            <p className="text-lg mb-8 text-orange-50 max-w-2xl mx-auto">
              Contact us today! We respond quickly and provide accurate, no-obligation quotes for all your moving, junk removal, and demolition needs.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button 
                onClick={() => window.location.href = `tel:${businessInfo.phone}`}
                className="bg-white text-orange-600 hover:bg-gray-100 px-8 py-6 text-lg font-semibold shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105"
              >
                <Phone className="mr-2" size={20} />
                Call {businessInfo.phone}
              </Button>
              <Button 
                onClick={() => window.location.href = `mailto:${businessInfo.email}`}
                className="bg-orange-700 hover:bg-orange-800 text-white px-8 py-6 text-lg font-semibold shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105"
              >
                <Mail className="mr-2" size={20} />
                Send Email
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
